/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as LoginRouteImport } from './routes/login';
import { Route as PatientsRouteImport } from './routes/patients';
import { Route as PatientsPatientIdRouteImport } from './routes/patients.$patientId';
import { Route as PatientsIndexRouteImport } from './routes/patients.index';
import { Route as PatientsNewRouteImport } from './routes/patients.new';
import { Route as PlatformRouteImport } from './routes/platform';
import { Route as SettingsAccountRouteImport } from './routes/settings.account';
import { Route as SettingsSecurityRouteImport } from './routes/settings.security';
import { Route as SettingsTeamRouteImport } from './routes/settings.team';
import { Route as ShareTokenRouteImport } from './routes/share.$token';
import { Route as SignupRouteImport } from './routes/signup';
import { Route as VisitsVisitIdRouteImport } from './routes/visits.$visitId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsRoute = PatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PatientsRoute,
} as any);
const PatientsPatientIdRoute = PatientsPatientIdRouteImport.update({
  id: '/$patientId',
  path: '/$patientId',
  getParentRoute: () => PatientsRoute,
} as any);
const PatientsNewRoute = PatientsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PatientsRoute,
} as any);
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/settings/team',
  path: '/settings/team',
  getParentRoute: () => rootRouteImport,
} as any);
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const VisitsVisitIdRoute = VisitsVisitIdRouteImport.update({
  id: '/visits/$visitId',
  path: '/visits/$visitId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/patients': typeof PatientsRouteWithChildren;
  '/platform': typeof PlatformRoute;
  '/signup': typeof SignupRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/patients/new': typeof PatientsNewRoute;
  '/settings/account': typeof SettingsAccountRoute;
  '/settings/security': typeof SettingsSecurityRoute;
  '/settings/team': typeof SettingsTeamRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/visits/$visitId': typeof VisitsVisitIdRoute;
  '/patients/': typeof PatientsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/platform': typeof PlatformRoute;
  '/signup': typeof SignupRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/patients/new': typeof PatientsNewRoute;
  '/settings/account': typeof SettingsAccountRoute;
  '/settings/security': typeof SettingsSecurityRoute;
  '/settings/team': typeof SettingsTeamRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/visits/$visitId': typeof VisitsVisitIdRoute;
  '/patients': typeof PatientsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/patients': typeof PatientsRouteWithChildren;
  '/platform': typeof PlatformRoute;
  '/signup': typeof SignupRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/patients/new': typeof PatientsNewRoute;
  '/settings/account': typeof SettingsAccountRoute;
  '/settings/security': typeof SettingsSecurityRoute;
  '/settings/team': typeof SettingsTeamRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/visits/$visitId': typeof VisitsVisitIdRoute;
  '/patients/': typeof PatientsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/patients'
    | '/platform'
    | '/signup'
    | '/patients/$patientId'
    | '/patients/new'
    | '/settings/account'
    | '/settings/security'
    | '/settings/team'
    | '/share/$token'
    | '/visits/$visitId'
    | '/patients/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/platform'
    | '/signup'
    | '/patients/$patientId'
    | '/patients/new'
    | '/settings/account'
    | '/settings/security'
    | '/settings/team'
    | '/share/$token'
    | '/visits/$visitId'
    | '/patients';
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/patients'
    | '/platform'
    | '/signup'
    | '/patients/$patientId'
    | '/patients/new'
    | '/settings/account'
    | '/settings/security'
    | '/settings/team'
    | '/share/$token'
    | '/visits/$visitId'
    | '/patients/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LoginRoute: typeof LoginRoute;
  PatientsRoute: typeof PatientsRouteWithChildren;
  PlatformRoute: typeof PlatformRoute;
  SignupRoute: typeof SignupRoute;
  SettingsAccountRoute: typeof SettingsAccountRoute;
  SettingsSecurityRoute: typeof SettingsSecurityRoute;
  SettingsTeamRoute: typeof SettingsTeamRoute;
  ShareTokenRoute: typeof ShareTokenRoute;
  VisitsVisitIdRoute: typeof VisitsVisitIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/patients': {
      id: '/patients';
      path: '/patients';
      fullPath: '/patients';
      preLoaderRoute: typeof PatientsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform': {
      id: '/platform';
      path: '/platform';
      fullPath: '/platform';
      preLoaderRoute: typeof PlatformRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/patients/': {
      id: '/patients/';
      path: '/';
      fullPath: '/patients/';
      preLoaderRoute: typeof PatientsIndexRouteImport;
      parentRoute: typeof PatientsRoute;
    };
    '/patients/$patientId': {
      id: '/patients/$patientId';
      path: '/$patientId';
      fullPath: '/patients/$patientId';
      preLoaderRoute: typeof PatientsPatientIdRouteImport;
      parentRoute: typeof PatientsRoute;
    };
    '/patients/new': {
      id: '/patients/new';
      path: '/new';
      fullPath: '/patients/new';
      preLoaderRoute: typeof PatientsNewRouteImport;
      parentRoute: typeof PatientsRoute;
    };
    '/settings/account': {
      id: '/settings/account';
      path: '/settings/account';
      fullPath: '/settings/account';
      preLoaderRoute: typeof SettingsAccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/security': {
      id: '/settings/security';
      path: '/settings/security';
      fullPath: '/settings/security';
      preLoaderRoute: typeof SettingsSecurityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/team': {
      id: '/settings/team';
      path: '/settings/team';
      fullPath: '/settings/team';
      preLoaderRoute: typeof SettingsTeamRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/share/$token': {
      id: '/share/$token';
      path: '/share/$token';
      fullPath: '/share/$token';
      preLoaderRoute: typeof ShareTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/visits/$visitId': {
      id: '/visits/$visitId';
      path: '/visits/$visitId';
      fullPath: '/visits/$visitId';
      preLoaderRoute: typeof VisitsVisitIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface PatientsRouteChildren {
  PatientsPatientIdRoute: typeof PatientsPatientIdRoute;
  PatientsNewRoute: typeof PatientsNewRoute;
  PatientsIndexRoute: typeof PatientsIndexRoute;
}

const PatientsRouteChildren: PatientsRouteChildren = {
  PatientsPatientIdRoute: PatientsPatientIdRoute,
  PatientsNewRoute: PatientsNewRoute,
  PatientsIndexRoute: PatientsIndexRoute,
};

const PatientsRouteWithChildren = PatientsRoute._addFileChildren(PatientsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PatientsRoute: PatientsRouteWithChildren,
  PlatformRoute: PlatformRoute,
  SignupRoute: SignupRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  ShareTokenRoute: ShareTokenRoute,
  VisitsVisitIdRoute: VisitsVisitIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
